import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import { RootState } from '../../app-state/store';

function Intercom() {
    const hideIntercom = false;
    const { boot, shutdown } = useIntercom();
    const { user } = useSelector((state: RootState) => state.auth);
    useEffect(() => {
        boot({
            name: user?.username,
            userId: user?.username,
            hideDefaultLauncher: hideIntercom,
        });
        return () => {
            shutdown();
        };
    }, [hideIntercom, boot, shutdown, user]);
    return null;
}
export default Intercom;
